import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'
import { CookieConsent } from '@utils'

/**
 * 페이지뷰 추적.
 * 분석 쿠키에 동의한 방문자에 대해서만 GA 를 초기화하고 전송한다.
 * 동의 전에는 GA 스크립트 자체를 올리지 않는다.
 */
const RouteChangeTracker = () => {
	const location = useLocation()
	const [initialized, setInitialized] = useState(false)
	const [hasConsent, setHasConsent] = useState(() => CookieConsent.isGranted())

	// 배너에서 동의/거부를 누르면 즉시 반영된다
	useEffect(() => {
		const unsubscribe = CookieConsent.subscribe(value => {
			setHasConsent(value === 'granted')
		})

		return unsubscribe
	}, [])

	useEffect(() => {
		if (!hasConsent || initialized) return
		if (!process.env.REACT_APP_GOOGLE_ANALYTICS) return

		ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS)
		setInitialized(true)
	}, [hasConsent, initialized])

	useEffect(() => {
		if (!initialized || !hasConsent) return

		ReactGA.set({ page: location.pathname })
		ReactGA.send('pageview')
	}, [initialized, hasConsent, location])
}

export default RouteChangeTracker
